import {Page} from './page';
import {SortOrder} from '../sort/sort-order';

export class PageRequest<T> {

  static firstPageRequest<T>(sortOrder: SortOrder, pageSize: number): PageRequest<T> {
    return new PageRequest<T>(
      sortOrder === SortOrder.ASCENDING,
      pageSize,
      1,
      0,
    );
  }

  static nextPageRequest<T>(currentPage: Page<T>): PageRequest<T> {
    return new PageRequest<T>(
      currentPage.isAscending(),
      currentPage.getPageSize(),
      currentPage.getNextPageNumber(),
      currentPage.getPageNumber(),
      currentPage.getFirstItemOnPage(),
      currentPage.getLastItemOnPage(),
    );
  }

  static previousPageRequest<T>(currentPage: Page<T>): PageRequest<T> {
    return new PageRequest<T>(
      currentPage.isAscending(),
      currentPage.getPageSize(),
      currentPage.getPreviousPageNumber(),
      currentPage.getPageNumber(),
      currentPage.getFirstItemOnPage(),
      currentPage.getLastItemOnPage(),
    );
  }

  constructor(public ascending: boolean,
              public pageSize: number,
              public pageNumber: number,
              public previousPageNumber: number,
              public firstItemPreviousPage?: T,
              public lastItemPreviousPage?: T,
  ) {
  }

  getSortOrder(): SortOrder {
    return this.ascending ? SortOrder.ASCENDING : SortOrder.DESCENDING;
  }

  getPageSize(): number {
    return this.pageSize;
  }

  toFirstPage(): PageRequest<T> {
    return PageRequest.firstPageRequest<T>(this.getSortOrder(), this.getPageSize());
  }
}
